import React from "react";
import TypeAheadSearchFocus from "../../TypeAheadSearchFocus/TypeAheadSearchFocus";
import {HeaderCenteredElementProps} from "../props";


const HeaderCenteredElement = ({searchBox, handleFocusChange, focusedSearch, centeredContainer}: HeaderCenteredElementProps) => {
  const focusChange = (focus: boolean) => {
    handleFocusChange?.(focus);
    searchBox?.onFocusChange?.(focus);
  }

  if (searchBox) {
    return (
      <TypeAheadSearchFocus
        {...searchBox}
        onFocusChange={focusChange}
        focus={focusedSearch}
      />
    );
  } else if (centeredContainer) {
    return <>{centeredContainer}</>;
  }
  return null;
}

export { HeaderCenteredElement };
